import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=6dd17338&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/hwy-staff-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd17338')) {
      api.createRecord('6dd17338', component.options)
    } else {
      api.reload('6dd17338', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=6dd17338&", function () {
      api.rerender('6dd17338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/material/Card.vue"
export default component.exports